import React, { useMemo, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPin, ArrowLeft } from 'lucide-react';
import { getEventsData } from '../data/eventsData';
import './EventDetail.css';

const EventDetail = () => {
  const { slug } = useParams();
  const { t } = useTranslation();

  const events = useMemo(() => getEventsData(t), [t]);
  const event = useMemo(() => events.find((item) => item.slug === slug), [events, slug]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!event) {
    return (
      <section className="event-detail section-padding">
        <div className="container">
          <div className="event-detail-not-found">
            <h2>{t('event_not_found', 'Event not found')}</h2>
            <Link to="/events" className="back-link">
              <ArrowLeft size={18} /> {t('back_to_events', 'Back to Events')}
            </Link>
          </div>
        </div>
      </section>
    );
  }

  const { title, image, date, venue, description, content } = event;
  const bodyContent = (content && content.trim().length > 0 ? content : description || '').split('\n');

  return (
    <article className="event-detail">
      <div className="event-detail-hero" style={{ backgroundImage: `url(${image})` }}>
        <div className="event-detail-overlay" />
        <div className="container">
          <div className="event-detail-hero-content">
            <span className="event-detail-date">
              <strong>{date.day}</strong>
              <span>{date.month}</span>
            </span>
            <h1>{title}</h1>
            <div className="event-detail-venue">
              <MapPin size={18} />
              <span>{venue}</span>
            </div>
          </div>
        </div>
      </div>

      <section className="event-detail-body section-padding">
        <div className="container">
          <div className="event-detail-content">
            <p className="event-detail-summary">{description}</p>
            <div className="event-detail-rich-text">
              {bodyContent.map((paragraph, index) => {
                const text = paragraph.trim();
                if (!text) return null;
                return <p key={index}>{text}</p>;
              })}
            </div>
            <Link to="/events" className="back-link">
              <ArrowLeft size={18} /> {t('back_to_events', 'Back to Events')}
            </Link>
          </div>
        </div>
      </section>
    </article>
  );
};

export default EventDetail;
